import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {withStyles} from '@material-ui/core/styles';
import {makeStyles} from '@material-ui/styles';
import {
  Grid,
  Button,
  IconButton,
  TextField,
  Checkbox,
  Typography,
} from '@material-ui/core';
import EmailIcon from '@material-ui/icons/Email';
import LockIcon from '@material-ui/icons/Lock';
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import {useTranslation} from 'react-i18next';
import {userActions} from '../../_actions';
import {connect} from 'react-redux';
import validate from 'validate.js';
import ReCAPTCHA from 'react-google-recaptcha';
// import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
// import FacebookIcon from "@material-ui/icons/Facebook";
import clsx from 'clsx';
import BottomInfo from '../../layouts/Minimal/components/BottomInfo';
import LoginPageContainer from '../../_components/LoginPageContainer';
import {SignInLogo} from '../../_components/Authorization/SignInLogo';
import {FormHeader} from '../../_components/Authorization/FormHeader';
import FormField from '../../_components/Authorization/FormField';
import ConfirmEmail from '../ConfirmEmail';

const useStyles = makeStyles(theme => ({
  root: {
    // backgroundColor: 'none' /*theme.palette.background.default,*/,
    // height: '100%',
  },
  root2: {
    height: 'calc(100vh - 888px)',
  },

  grid: {
    height: '100%',
  },
  content: {
    // textAlign: 'center',
    // display: 'contents',
    // flexDirection: 'column',
  },
  contentBody: {
    // marginTop: 20,
    // flexGrow: 1,
    // display: 'inline-flex',
    // alignItems: 'center',
    // [theme.breakpoints.down('md')]: {
    //     justifyContent: 'center',
    // },
  },
  form: {
    // maxWidth: 392,
    // width: '100%',
    // margin: '0 auto',
    // background: '#fff',
    // padding: 10,
    // [theme.breakpoints.down('md')]: {
    //     flexBasis: 600,
    //     paddingLeft: theme.spacing(2),
    //     paddingRight: theme.spacing(2),
    // },
    // [theme.breakpoints.down('sm')]: {
    //     flexBasis: '100%',
    //     paddingLeft: theme.spacing(2),
    //     paddingRight: theme.spacing(2),
    // },
  },
  //iconButton: {padding: 0},
  iconButton: {
    color: '#546e7a50',
    alignSelf: 'baseline',
    padding: '2px 8px 8px 8px',
  },
  icons: {
    display: 'block',
    fontSize: 30,
    color: '#616161',
  },
  checkbox: {
    display: 'flex',
    flexFlow: ' row wrap',
    alignItems: ' center',
    fontSize: 14,
    padding: '9px 4px 9px 2px',
    height: 62,
    marginBottom: 16,
    '& a': {
      textDecoration: 'none',
      color: '#006ce5',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
  checkboxText: {
    // marginTop: 0,
    // marginLeft: 8,
    // textAlign: 'left',
  },
  registered: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    // alignItems: 'center',
    fontSize: 14,
    '& p': {
      margin: 0,
    },
    '& a': {
      // position: 'absolute',
      // left: '50%',
      // transform: 'translateX(-50%)',
      textDecoration: 'none',
      color: '#7a7a7a',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
  title: {
    // marginTop: theme.spacing(3),
    // marginBottom: theme.spacing(3),
    // fontWeight: 400,
    // fontSize: 26,
    // color: '#000',
  },
  captcha: {margin: '0 auto'},
  button: {
    margin: '1em 0',
  },
  socialButtons: {
    marginTop: theme.spacing(3),
  },
  socialIcon: {
    marginRight: theme.spacing(1),
  },
  sugestion: {
    marginTop: theme.spacing(2),
  },
  textField: {
    marginBottom: theme.spacing(3),
    height: 36,
  },
  textFieldInput: {
    paddingLeft: 14,
    '& .MuiFormHelperText-root': {
      color: '#d32f2f',
    },
  },
  textFieldInputDoubleIcon: {
    // padding: '0 8px 0 14px',
    paddingLeft: 14,
    '& .MuiFormHelperText-root': {
      color: '#d32f2f',
    },
  },
  textField2: {
    marginTop: theme.spacing(2),
  },
  SignUpButton: {
    margin: theme.spacing(2, 0),
  },
  socialIcons: {
    color: '#444',
    fontSize: '4em',
    margin: '0 0.2em',
  },
  socialWrap: {
    width: '100%',
    textAlign: 'center',
    '& hr': {
      // margin: '2em 0 1em',
    },
    '& p': {
      fontSize: 14,
      color: '#929292',
    },
  },
  social: {
    display: 'flex',
    justifyContent: 'center',
    align: 'center',
    cursor: 'pointer',
  },
  numberInput: {
    '& input': {
      '-webkit-appearance': 'none',
      '-moz-appearance': 'textfield',
      appearance: 'none',
    },
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
}));

const schema = {
  tel: {
    presence: {allowEmpty: false, message: 'is required'},
  },
  email: {
    presence: {allowEmpty: false, message: 'is required'},
    email: true,
    length: {minimum: 5, maximum: 64},
  },
  password1: {
    presence: {allowEmpty: false, message: 'is required'},
    length: {minimum: 8, maximum: 64},
  },
  password2: {
    presence: {allowEmpty: false, message: 'is required'},
    length: {minimum: 8, maximum: 64},
  },
  captcha: {
    presence: {allowEmpty: false, message: 'is required'},
    length: {minimum: 8},
  },
};

const ColorCheckbox = withStyles({
  root: {
    color: '#616161',
    '&$checked': {
      color: '#006ce5',
    },
  },
  checked: {},
})(props => <Checkbox color="default" {...props} />);

const SignUp = props => {
  const {t} = useTranslation();
  const {authentication, register} = props;
  const classes = useStyles();
  const [wrapperHeight, setWrapperHeight] = useState('100vh');

  const [formState, setFormState] = useState({
    isValid: false,
    isSend: false,
    values: {
      tel: '',
      email: '',
      password1: '',
      password2: '',
      checked: false,
    },
    touched: {},
    errors: {},
  });

  function formatPhoneNumber(value, previousValue = '') {
    const cleanValue = value.replace(/\D/g, '');

    if (previousValue && value.length < previousValue.length) {
      if (cleanValue.length < 3) {
        return '+380';
      }

      const formattedParts = [
        '+380',
        cleanValue.slice(3, 5),
        cleanValue.slice(5, 8),
        cleanValue.slice(8, 9),
        cleanValue.slice(9, 13),
      ];

      return formattedParts
        .filter(part => part)
        .join(' ')
        .trim();
    }

    if (!cleanValue.startsWith('380')) {
      return '+380 ' + cleanValue.replace(/^0*/, '');
    }

    if (cleanValue.length > 3) {
      const formattedNumber =
        '+380 ' +
        cleanValue.slice(3, 5) +
        ' ' +
        cleanValue.slice(5, 8) +
        ' ' +
        cleanValue.slice(8, 10) +
        ' ' +
        cleanValue.slice(10, 13);

      return formattedNumber.trim();
    }

    return '+380 ' + cleanValue.slice(3);
  }

  function myvalidate(formData, errors) {
    if (formData.password1 !== formData.password2) {
      if (!errors) errors = {};
      if (!errors.password2) errors.password2 = [];
      errors.password2.push("===Passwords don't match");
    }
    if (!formData.checked) {
      if (!errors) errors = {};
      if (!errors.checked) errors.checked = [];
      errors.checked.push("===Don't checked");
    }

    // if (!/^(\+|0)/.test(formData.tel)) {
    //   if (!errors) errors = {};
    //   if (!errors.tel) errors.tel = [];
    //   errors.tel.push("===Number must start with '+' or '0'");
    // }
    //
    // let maxLength = formData.tel.startsWith('+') ? 13 : 10;
    // if (formData.tel.length > maxLength) {
    //   errors.tel = errors.tel || [];
    //   errors.tel.push(`===Number must be less than ${maxLength} digits`);
    // }

    const phoneNumber = formData.tel.replace(/\D/g, '');

    if (phoneNumber.length !== 12) {
      if (!errors) errors = {};
      if (!errors.tel) errors.tel = [];
      errors.tel.push('===Invalid phone number length');
      return errors;
    }

    if (!phoneNumber.startsWith('380')) {
      if (!errors) errors = {};
      if (!errors.tel) errors.tel = [];
      errors.tel.push('===Phone number must start with +380');
      return errors;
    }

    // const validOperatorCodes = ['39', '50', '63', '66', '67', '68', '73', '91', '92', '93', '94', '95', '96', '97', '98', '99'];
    // const operatorCode = phoneNumber.slice(3, 5);

    // if (!validOperatorCodes.includes(operatorCode)) {
    //   if (!errors) errors = {};
    //   if (!errors.tel) errors.tel = [];
    //   errors.tel.push('===Invalid Ukrainian operator code');
    // }

    return errors;
  }

  useEffect(() => {
    if (formState.touched['tel'] && authentication.error) {
      authentication.error.response.data.tel = null;
      setFormState(formState => ({...formState, isSend: false}));
    }
    if (formState.touched['email'] && authentication.error) {
      authentication.error.response.data.email = null;
      setFormState(formState => ({...formState, isSend: false}));
    }
    if (formState.touched['password1'] && authentication.error) {
      authentication.error.response.data.password1 = null;
      setFormState(formState => ({...formState, isSend: false}));
    }

    let errors = validate(formState.values, schema);
    errors = myvalidate(formState.values, errors);
    if (
      formState.values.tel == '' ||
      formState.values.email == '' ||
      formState.values.password1 == '' ||
      formState.values.password2 == '' ||
      formState.values.captcha == null ||
      errors.password1 ||
      errors.password2
    ) {
      setDisable(true);
    } else {
      setDisable(false);
    }
    setFormState(formState => ({
      ...formState,
      isValid: !errors,
      errors: errors || {},
    }));
  }, [formState.touched, formState.values, authentication.error]);

  const hasError = field =>
    !!(formState.touched[field] && formState.errors[field]);

  const [passIsShow, togglePassType] = useState(false);
  const [secondPassIsShow, toggleSecondPassType] = useState(false);
  const [disabledBtn, setDisable] = useState(false);

  const handleChange = event => {
    event.persist();

    const {name, value, type, checked} = event.target;
    let newValue = value;

    if (name === 'tel') {
      // newValue = newValue.replace(/[^\d+]/g, '');
      newValue = formatPhoneNumber(newValue);

      if (newValue.replace(/\D/g, '').length > 12) {
        return;
      }

      // if (newValue.length === 1 && !/^[0+]$/.test(newValue)) {
      //   return;
      // }
      //
      // if (newValue.length > maxLength) {
      //   newValue = newValue.slice(0, maxLength);
      // }
    }

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [name]: type === 'checkbox' ? checked : newValue,
      },
      touched: {
        ...formState.touched,
        [name]: true,
      },
    }));
  };

  /*
    const responseFacebook = (response) => {
      if (response.accessToken) {
        loginSocial(response.accessToken, 'rest-auth/facebook/', response.name)
      }
    };
  */

  const handleCaptcha = value => {
    // this.props.handleCaptcha(value);
    const captcha = 'captcha';
    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [captcha]: value,
      },
    }));
  };

  const handleSignUp = event => {
    event.preventDefault();
    setFormState(formState => ({...formState, isSend: true}));

    // formState.touched["password1"]=false;
    // formState.touched["email"]=false;
    setFormState(formState => ({...formState, touched: {}}));
    const {tel, password1, email, captcha} = formState.values;
    const modernizedTel = tel.replace(/\s/g, '');
    register(modernizedTel, email, password1, captcha);
    window.grecaptcha.reset();
  };

  useEffect(() => {
    const handleResize = () => {
      const {innerHeight: h, innerWidth: w} = window;
      let newHeight = '100vh';

      if (h <= 770 && w > 991) {
        newHeight = `${100 + Math.floor((770 - h) / 10) * 2}vh`;
      } else if (h < 930 && w <= 991) {
        const totalHeight = 100 + Math.floor((930 - h) / 5) * 3;
        newHeight = `${Math.min(totalHeight, 140)}vh`;
      }

      setWrapperHeight(newHeight);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="user-main__wrapper" style={{height: wrapperHeight}}>
      <div className="user-main__inner">
        <SignInLogo />
        <div className="user-main__right">
          <div className="user-main__right-form user-form user-form-registration">
            <FormHeader />
            <div className="tab-content mb-0 mt-0">
              <div data-opened="tab-2" className="tab-pane active">
                <FormField
                  type="tel"
                  name="tel"
                  title={t('common:enter_phone')}
                  handleChange={handleChange}
                  formState={formState}
                  hasErrorText={t('common:enter_phone3')}
                  authentication={authentication}
                  maxLength={19}
                />
                {/*<Typography color="error" style={{fontSize: '14px'}}>
                  {authentication?.error?.response?.data?.phone?.phone}
                </Typography> */}
                <FormField
                  type="email"
                  name="email"
                  title={t('common:enter_email')}
                  handleChange={handleChange}
                  formState={formState}
                  hasErrorText={t('common:enter_email2')}
                  authentication={authentication}
                />
                {/* <Typography color="error" style={{fontSize: '14px'}}>
                  {authentication?.error?.response?.data?.email}
                </Typography> */}
                {/* <TextField
                  style={{
                    background: '#EBF0F8',
                    fontWeight: '600',
                    borderColor: '#EBF0F8',
                    color: '#1F1F1F',
                    borderRadius: '50px',
                    padding: '25px 25px 10px 35px',
                  }}
                  name="email"
                  value={formState.values.email}
                  type={'email'}
                  onChange={handleChange}
                  fullWidth
                  placeholder={t('common:enter_email')}
                  helperText={
                    hasError('email')
                      ? t('common:enter_email2')
                      : authentication.error &&
                        authentication.error.response &&
                        authentication.error.response.data.email
                      ? authentication.error.response.data.email
                      : null
                  }
                  error={
                    hasError('email') ||
                    (authentication.error &&
                      authentication.error.response &&
                      authentication.error.response.data.email &&
                      true)
                  }
                /> */}

                <FormField
                  type="password"
                  name="password1"
                  title={t('common:enter_password')}
                  handleChange={handleChange}
                  formState={formState}
                  authentication={authentication}
                />
                <FormField
                  type="password"
                  name="password2"
                  title={t('common:confirm_password')}
                  handleChange={handleChange}
                  formState={formState}
                  authentication={authentication}
                />
                {/*<Typography color="error" style={{fontSize: '14px'}}>*/}
                {/*  {authentication?.error?.response?.data.password1}*/}
                {/*</Typography>*/}
                <div className="form__field mb-4 mt-6">
                  <label htmlFor="checkbox1" className="checkbox">
                    <input
                      type="checkbox"
                      id="checkbox1"
                      className="checkbox__input"
                    />
                    <span className="checkbox__marker"></span>
                    <span className="checkbox__text">
                      {t('common:I accept the conditions')}{' '}
                      <Link to="/user_agreement">
                        {t('common:user_agreement2')}
                      </Link>
                    </span>
                  </label>
                </div>
                <div className="user-form__captcha mb-4">
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA}
                    onChange={handleCaptcha}
                  />
                </div>
                <button
                  onClick={handleSignUp}
                  className={`${
                    disabledBtn ? 'btn-disabled' : 'btn'
                  } btn-big btn--w100 mb-0`}>
                  {t('common:REGISTRATION')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    //     <LoginPageContainer className={'registration_form'}>
    //       <form className={clsx(classes.form, 'form')} onSubmit={handleSignUp}>
    //         <Typography className={clsx(classes.title, 'title')} variant="h2">
    //           {t('common:create_account')}
    //         </Typography>
    //         {/*
    //                 {(authentication.error) &&
    //                 <Typography color="error">
    //                   {authentication.error.response.data.email}
    //                 </Typography>
    //                 }
    // */}
    //         <Grid container className={classes.textField}>
    //           <Grid item xs={1}>
    //             <EmailIcon className={classes.icons}/>
    //           </Grid>
    //           <Grid item xs={11} className={classes.textFieldInput}>
    //             <TextField
    //               name="email"
    //               value={formState.values.email}
    //               type={'email'}
    //               onChange={handleChange}
    //               fullWidth
    //               placeholder={t('common:enter_email')}
    //               helperText={
    //                 hasError('email') ? t('common:enter_email2') :
    //                   ((authentication.error) && (authentication.error.response)
    //                     && (authentication.error.response.data.email)) ?
    //                     authentication.error.response.data.email : null
    //               }
    //               error={hasError('email') || ((authentication.error)
    //                 && (authentication.error.response)
    //                 && (authentication.error.response.data.email) && true)}
    //             />
    //           </Grid>
    //         </Grid>

    //         <Grid container className={classes.textField}>
    //           <Grid item xs={1}>
    //             <LockIcon className={classes.icons}/>
    //           </Grid>
    //           <Grid item xs={11} style={{display: "flex"}}
    //                 className={classes.textFieldInputDoubleIcon}>
    //             <TextField
    //                 style={{marginRight: -48}}
    //               fullWidth
    //               name="password1"
    //               value={formState.values.password1 || ''}
    //               onChange={handleChange}
    //               placeholder={t('common:Enter your password')}
    //               type={passIsShow ? 'text' : 'password'}
    //               helperText={
    //                 (hasError('password1')
    //                   && t('common:Password must be at least 8 characters')) ||
    //                 ((authentication.error) && (authentication.error.response)
    //                   && (authentication.error.response.data.password1)
    //                   && authentication.error.response.data.password1[0])
    //               }
    //               error={hasError('password1') ||
    //               ((authentication.error) && (authentication.error.response)
    //                 && (authentication.error.response.data.password1) && true)}
    //             />
    //             <IconButton
    //               className={classes.iconButton}
    //               aria-label="password"
    //               onClick={() => togglePassType(!passIsShow)}>
    //               {passIsShow ? (
    //                 <VisibilityOutlinedIcon className={classes.icons}/>
    //               ) : (
    //                 <VisibilityOffOutlinedIcon className={classes.icons}/>
    //               )}
    //             </IconButton>
    //           </Grid>
    //         </Grid>

    //         <Grid container className={classes.textField}>
    //           <Grid item xs={1}>
    //             <LockIcon className={classes.icons}/>
    //           </Grid>
    //           <Grid item xs={11} style={{display: "flex"}}
    //                 className={classes.textFieldInputDoubleIcon}>
    //             <TextField
    //                 style={{marginRight: -48}}
    //               name="password2"
    //               fullWidth
    //               value={formState.values.password2 || ''}
    //               onChange={handleChange}
    //               placeholder={t('common:confirm_password')}
    //               helperText={hasError('password2') ? t('common:Passwords do not match') : ''}
    //               // label={t('common:confirm_password')}
    //               type={secondPassIsShow ? 'text' : 'password'}
    //               error={hasError('password2')}
    //             />
    //              <IconButton
    //               className={classes.iconButton}
    //               aria-label="password"
    //               onClick={() => toggleSecondPassType(!secondPassIsShow)}>
    //               {secondPassIsShow ? (
    //                 <VisibilityOutlinedIcon className={classes.icons}/>
    //               ) : (
    //                 <VisibilityOffOutlinedIcon className={classes.icons}/>
    //               )}
    //             </IconButton>
    //           </Grid>
    //         </Grid>

    //         <Grid container spacing={1}>
    //           <Grid item xs={12} lg={12}>
    //             <Grid container className='checkbox_container'>
    //               <Grid item xs={1} lg={1}>
    //                 <ColorCheckbox
    //                   name="checked"
    //                   className="checkbox_block"
    //                   value="policy"
    //                   checked={formState.values.checked}
    //                   onChange={handleChange}
    //                 />
    //               </Grid>
    //               <Grid item xs={11} lg={11}>
    //                 <Typography variant={"body2"} className="checkbox_text">
    //                   {t('common:I accept the conditions')}&nbsp;
    //                   <Link to="/user_agreement" target="_blank">
    //                     {t('common:privacy policies')}
    //                   </Link>
    //                 </Typography>
    //               </Grid>
    //             </Grid>
    //           </Grid>
    //         </Grid>

    //         <Grid container>
    //           <Grid item className={classes.captcha}>
    //             <ReCAPTCHA
    //               sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA}
    //               onChange={handleCaptcha}
    //             />
    //           </Grid>
    //         </Grid>

    //         <Button
    //           variant="contained"
    //           color="secondary"
    //           type="submit"
    //           disabled={formState.isSend || !formState.isValid}
    //           fullWidth
    //           className={classes.button}>
    //           {t('common:REGISTRATION')}
    //         </Button>

    //         <Grid container>

    //           <Grid item className={classes.registered}>
    //             <Typography
    //               variant={"body2"}>
    //               {t('common:Already have an account')}&nbsp;&nbsp;
    //               <Link to="/sign-in">{t('common:come_in')}</Link>
    //             </Typography>
    //           </Grid>

    //         </Grid>

    //         <BottomInfo/>
    //       </form>
    //     </LoginPageContainer>
  );
};

// export default withRouter(SignUp);
function mapState(state) {
  // function mapState() {
  const {authentication} = state;
  // const {loggedIn} = state.authentication;
  // return {loggedIn, authentication};
  return {authentication};
}

const actionCreators = {
  // logout: userActions.logout,
  register: userActions.register,
};

class Wrapper extends React.Component {
  componentDidMount() {
    this.props.authentication.error = null;
  }

  render() {
    return <SignUp {...this.props} />;
  }
}

export default connect(mapState, actionCreators)(Wrapper);
